
import {ExportRegistry} from "./ExportRegistry.js";
import {buildExportFilename} from "./exportFilename.js";
import {buildCsvText} from "./csv/csvGenerator.js";
import {csvProfileStore} from "./csv/CsvProfileStore.js";

import {t, T} from "../i18n/index.js";
// Task: "Den eksisterende CSV-eksport skal så vidt muligt videreføres som
// en standardprofil i det nye system. Der skal ikke opstå to parallelle
// CSV-implementeringer." - this file used to CONTAIN the fixed CSV logic
// (see git history); it now only orchestrates: resolve which profile to
// use, hand profile+features to the generic csv/ pipeline
// (csv/csvGenerator.js, driven by csv/dataSources.js), and wrap the result
// for ExportRegistry. No CSV-format knowledge lives here any more - this is
// the "profil + features -> outputrækker -> CSV" contract itself, not a
// second implementation next to it.
//
// `context.csvProfile`: the profile object the export UI's dropdown
// resolved (see RegistreringerPanel.js) - falls back to the store's
// default ("Standard PointView") for any caller that doesn't pass one
// (tests, or a future programmatic export), so this exporter is never
// unusable without the UI wiring.
export const CSVFeatureExporter = {
	id: "csv",
	name: T("CSV"),
	extension: "csv",
	disabled: false,
	description: T("Tabel efter en CSV-profil (Standard PointView eller en gemt profil)."),
	crsHandling: "none",
	// Formatspecifikke indstillinger til en host-UI (se exportFacade.js).
	options(){
		return [{
			id: "csvProfileId",
			type: "select",
			label: t("CSV-profil"),
			choices: csvProfileStore.list().map((p) => ({id: p.id, name: p.name})),
			default: csvProfileStore.getDefault().id,
		}];
	},
	prepareContext(options = {}, context = {}){
		const profile = options.csvProfileId ? csvProfileStore.get(options.csvProfileId) : null;
		return {...context, csvProfile: profile || undefined};
	},
	export(features, context = {}){
		const profile = context.csvProfile || csvProfileStore.getDefault();
		const text = buildCsvText(profile, features);

		return {
			filename: buildExportFilename(context.pointcloudName, "csv", context.exportDate),
			text,
			mimeType: "text/csv",
		};
	},
};

ExportRegistry.register(CSVFeatureExporter);
